module.exports = __webpack_public_path__ + "img/covid.a83da191.png";